import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { tunnelsDataId } from "../../../../../../store/actions/users/getTunnelData";
import { UIactions } from "../../../../../../store/slices/UI";
import { c365devicesListDataId } from "../../../../../Reports/Actions/getc365List";
import { default as CustomDevicePicker } from "../../../../../UI/Specialized/DevicePicker";
import { tunnelTokenId } from "../../Actions/getMachineStatus";
import { selectionBlockUI } from "../../RemoteSelection";
import { passFieldId } from "../Blocked/PassField";

const DevicePicker = ({ user, useCloud }) => {
  const { dispatch, warehouse } = useUIBp();
  const tunnels = warehouse[tunnelsDataId] ?? {};
  const c365Devices = warehouse[c365devicesListDataId] ?? {};
  const c365Mid = c365Devices[user] ?? undefined;
  let whitelist = tunnels[user] ?? undefined;
  let finalWhitelist = []

  if (useCloud){
    finalWhitelist.push(c365Mid);
  } else {
    if (!whitelist) {
      finalWhitelist = [];
    }
    finalWhitelist = whitelist ? [...whitelist] : [];
  }

  // if (c365Mid) {
  //   if (!whitelist) {
  //     whitelist = [];
  //   }
  //    whitelist = whitelist ? [...whitelist] : [];
  //   whitelist.push(c365Mid);
  // }
  // console.log("365mid", c365Mid);

  const onChange = () => {
    dispatch(UIactions.clear(tunnelTokenId));
    dispatch(UIactions.clear(selectionBlockUI));
    dispatch(UIactions.clear(passFieldId));
  };

  return (
    <CustomDevicePicker
      autoload
      useWhitelist
      clearOnUnmount
      {...{ user, whitelist:finalWhitelist, onChange, size: 12 }}
    />
  );
};

export default DevicePicker;
